import React, { MutableRefObject } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faClone, faFileExport, faPlusCircle, faTrash, faShare } from "@fortawesome/free-solid-svg-icons";
import { Assistant } from "../types/assistant";

interface AssistantOptionsMenuProps {
  assistant: Assistant;
  optionsRef: MutableRefObject<{ [key: string]: HTMLDivElement | null }>;
  handleCoOwner?: (assistant: Assistant) => void;
  handleCopyAppUrl: (appId: string) => void;
  handleClone: (appId: string, appName: string) => void;
  handleExport: (assistant: Assistant) => void;
  handleMergeClick?: (assistant: Assistant) => void;
  handleDelete?: (appId: string) => void;
  type?: string;
}

const AssistantOptionsMenu: React.FC<AssistantOptionsMenuProps> = ({
  assistant,
  optionsRef,
  handleCoOwner,
  handleCopyAppUrl,
  handleClone,
  handleExport,
  handleMergeClick,
  handleDelete,
  type,
}) => {
  const isPublished = assistant?.app_publishstatus?.toUpperCase() === "PUBLISHED";
  const currentNetId = localStorage.getItem("netId");
  let isCurrentUserCoOwner = assistant?.co_owner?.some(
    (owner: { net_id: string; role: string }) =>
      owner.net_id === currentNetId && owner.role === "co-owner"
  );

  if (type === 'virtual-list') {
    isCurrentUserCoOwner = true;
  }

  return (
    <div
      ref={(el) => (optionsRef.current[assistant.app_id] = el)}
      className="options-menu"
    >
      {handleCoOwner && isCurrentUserCoOwner && (
      <button
        onClick={(e) => {
          e.stopPropagation();
          handleCoOwner(assistant);
        }}
        className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
      >
        <FontAwesomeIcon icon={faShare} className="mr-2" />
          Share
      </button>
      )}

      <button
        onClick={(e) => {
          e.stopPropagation();
          if (isPublished) handleCopyAppUrl(assistant.app_id);
        }}
        className={`block w-full text-left px-4 py-2 ${
          isPublished
            ? "text-gray-700 hover:bg-gray-100"
            : "text-gray-400 cursor-not-allowed"
        }`}
        disabled={!isPublished}
        title={!isPublished ? "Publish assistant to enable URL copying" : ""}
      >
        <FontAwesomeIcon icon={faCopy} className="mr-2" />
        Copy App URL
      </button>

      <button
        onClick={(e) => {
          e.stopPropagation();
          handleClone(assistant.app_id, assistant.app_name);
        }}
        className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
      >
        <FontAwesomeIcon icon={faClone} className="mr-2" />
        Create Copy
      </button>

      <button
        onClick={(e) => {
          e.stopPropagation();
          handleExport(assistant);
        }}
        className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
      >
        <FontAwesomeIcon icon={faFileExport} className="mr-2" />
        Export
      </button>

      {handleMergeClick && (
      <button
        onClick={(e) => {
          e.stopPropagation();
          handleMergeClick(assistant);
        }}
        className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
      >
        <FontAwesomeIcon icon={faPlusCircle} className="mr-2" />
        Merge
      </button>
      )}
      {handleDelete && (
      <button
        onClick={(e) => {
          e.stopPropagation();
          handleDelete(assistant.app_id);
        }}
        className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
      >
        <FontAwesomeIcon icon={faTrash} className="mr-2" />
        Delete
      </button>
      )}
    </div>
  );
};

export default AssistantOptionsMenu;
